import React, { Component } from "react";
import { Button, Image, Row, Col } from "react-bootstrap";
// import { QRCode } from "react-qr-svg";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import StickerQrComponent from "../../../../../../reusableComponents/QRCodePrintAndExport/StickerQrComponent";
import TableTentCardComponent from "../../../../../../reusableComponents/QRCodePrintAndExport/TableTentCardComponent";
import BasicPagination from "../../../../../../Pagination/Pagination";

export class PrintSecondComponentQrCode extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    return (
      <div>
        <ComponentToPrint
          ref={(el) => (this.componentRef = el)}
          onboarding={this.props?.onboarding}
          vendorId={this.props?.vendor_id}
          qrData={this.props.qrData}
          typeOfQr={this.props.typeOfQr}
          formikValueOne={this.props.formikValue}
        />
        {this.props.qrData.length !== 0 ? (
          <div className="row">
            <div className="col-12">
              <BasicPagination
                totalRecords={this.props.totalRecords}
                limit={this.props.totalLimit}
                batch={this.props.page}
                onBatchChange={this.props.handleBatchChange}
              />
            </div>
          </div>
        ) : (
          // totalPages
          // totalRecords
          <></>
        )}
        <Row className="mt-3">
          <Col sm={4} md={2}>
            <Button
              title="Cancel"
              type="button"
              variant="outline-secondary"
              className="w-100"
              style={{
                borderRadius: 5,
                fontWeight: 400,
                fontSize: 12,
                padding: 12,
              }}
              onClick={this.props.setOpenPrintPreview}
            >
              Cancel
            </Button>
          </Col>
          <Col sm={4} md={2}>
            <ReactToPrint
              trigger={() => (
                <Button
                  title="Print Preview"
                  type="button"
                  className="text-white w-100"
                  variant="danger"
                  style={{
                    borderRadius: 5,
                    fontWeight: 400,
                    fontSize: 12,
                    padding: 12,
                  }}
                >
                  Print
                </Button>
              )}
              content={() => this.componentRef}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class ComponentToPrint extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    return (
      <div
        className="row d-flex align-items-center border shadow-md rounded p-4"
        style={{
          width: "100%",
          height: "auto",
          // flexWrap: "wrap",
        }}
      >
        {this.props.qrData.map((data, index) => {
          let tableData = "";
          let tableDataObject = {};
          tableData =
            this.props?.typeOfQr === "table"
              ? data?.table_number
              : data?.seat_number;
          tableDataObject.restaurant_id = this.props.onboarding?._id;
          if (this.props.typeOfQr === "table") {
            tableDataObject.table_number = data?.table_number;
          } else {
            tableDataObject.seat_number = data?.seat_number;
          }
          tableDataObject.type =
            this.props.typeOfQr === "table"
              ? "table_management"
              : "seat_management";
          tableDataObject.vendor_id = this.props.vendorId;
          return this.props.formikValueOne.values?.qrCodeType === "Sticker" ? (
            <Col className="col-4 mb-4" key={index}>
              <StickerQrComponent
                keysData={index}
                qrData={tableDataObject}
                sizeData={this.props.formikValueOne?.values?.qrCodeSize || 150}
                logo={
                  this.props.onboarding?.logo_url_thumbnails ||
                  this.props.onboarding?.logo_url
                }
                name={this.props.onboarding?.restaurant_name}
              />
            </Col>
          ) : (
            <Col className="col-4 mb-4" key={index}>
              <TableTentCardComponent
                keysData={index}
                qrData={tableDataObject}
                sizeData={this.props.formikValueOne?.values?.qrCodeSize || 150}
                logo={
                  this.props.onboarding?.logo_url_thumbnails ||
                  this.props.onboarding?.logo_url
                }
                name={this.props.onboarding?.restaurant_name}
              />
            </Col>
          );
        })}
      </div>
    );
  }
}

export default PrintSecondComponentQrCode;
